module.exports = __webpack_public_path__ + "img/icon-add-gray.3bbdffa9.svg";